import React, { useMemo, useState } from "react";
import {
  Box,
  Typography,
  Popover,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { MENU_ICONS, resolveMenuIcon } from "../../utils/menuIcons";

const IconPickerField = ({ value, onChange, label = "Icon (opsional)" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const open = Boolean(anchorEl);

  const selected = MENU_ICONS.find((item) => item.name === value);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return MENU_ICONS;
    return MENU_ICONS.filter(
      (item) =>
        item.name.toLowerCase().includes(term) ||
        item.label.toLowerCase().includes(term)
    );
  }, [search]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setSearch("");
  };

  const handlePick = (name) => {
    onChange(name);
    handleClose();
  };

  return (
    <Box>
      <Typography sx={{ mb: 0.5 }}>{label}</Typography>
      <Box
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: "1px solid rgba(0,0,0,0.23)",
          borderRadius: "20px",
          px: 2,
          py: 1,
          cursor: "pointer",
          "&:hover": { borderColor: "rgba(0,0,0,0.5)" },
        }}
      >
        {selected ? resolveMenuIcon(selected.name) : null}
        <Typography color={selected ? "text.primary" : "text.secondary"}>
          {selected ? selected.label : "Pilih icon"}
        </Typography>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2, width: 340 }}>
          <TextField
            autoFocus
            size="small"
            fullWidth
            placeholder="Cari icon..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mb: 1.5 }}
          />
          <Box
            onClick={() => handlePick(null)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1,
              py: 0.75,
              borderRadius: 1,
              cursor: "pointer",
              mb: 1,
              "&:hover": { backgroundColor: "rgba(0,49,88,0.08)" },
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Tidak ada icon
            </Typography>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)",
              gap: 0.5,
              maxHeight: 260,
              overflowY: "auto",
            }}
          >
            {filtered.map((item) => (
              <Tooltip key={item.name} title={item.label}>
                <IconButton
                  onClick={() => handlePick(item.name)}
                  sx={{
                    border: item.name === value ? "2px solid #003158" : "1px solid transparent",
                  }}
                >
                  <item.Icon fontSize="small" />
                </IconButton>
              </Tooltip>
            ))}
          </Box>
          {filtered.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 2 }}>
              Icon tidak ditemukan
            </Typography>
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default IconPickerField;
